import React from 'react'
import useViewModel from './ViewModel'

const TotalSaleChart = () => {
	const { chartRef } = useViewModel()

	return (
		<React.Fragment>
			<div className={`card h-100 border border-kumopack-grey-200`}>
				{/* begin::Body */}
				<div className="card-body px-0 pt-0">
					{/* begin::Chart */}
					<div
						ref={chartRef}
						id="kt_charts_total_sale_chart"
						style={{ height: '350px' }}
						className="card-rounded-bottom"></div>
					{/* end::Chart */}
				</div>
				{/* end::Body */}
			</div>

			<style>
				{`
              #kt_charts_total_sale_chart .apexcharts-legend {
                  display: flex;
                  flex-direction: column;
                  align-items: flex-end;
              }
          `}
			</style>
		</React.Fragment>
	)
}

export default TotalSaleChart
